// extracted by mini-css-extract-plugin
module.exports = {"slideWrapper":"qX","imageWrapper":"qY","image":"qZ","copyrightAndBrandLogo":"q0","brandLogo":"q1","copyright":"q2","rentalBadge":"q3"};